import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';

export default class ArticlePreviewHK extends React.Component {

    obtemTipoBadge(tipo) {

        let _tipoBadge,
            _textColorInside = 'white',
            _textColorOutside,
            _textColorDestaque = 'white',
            _cardColor;

        switch (tipo.toLowerCase()) {
            case "bm":
                _tipoBadge = 'verdeBM';
                _textColorOutside = _tipoBadge;
                _cardColor = 'verdeBM';
                break;
            case "tc":
                _tipoBadge = 'danger';
                _textColorOutside = _tipoBadge;
                _cardColor = 'danger';
                break;
            case "rd":
                _tipoBadge = 'warning';
                _textColorOutside = _tipoBadge;
                _textColorInside = 'cinzaRD';
                _textColorDestaque = 'cinzaRD';
                _cardColor = 'warning';
                break;
            default:
                _tipoBadge = 'primary';
                _textColorOutside = _tipoBadge;
                _cardColor = 'primary';
                break;
        }
        return {
            textColorInside: `text-${_textColorInside}`,
            textColorOutside: `texto-subtitulo-${_textColorOutside}`,
            textColorBadgeWhite: `text-${_textColorOutside}`,
            badgeColor: `badge-${_tipoBadge}`,
            borderLine: `border-${_tipoBadge}`,
            cardColor: _cardColor,
            textColorDestaque: `text-${_textColorDestaque}`,
        }
    }

    adicionarDivImgs(_texto) {
        const _imgPreOrig = new RegExp(`<img`, 'g');
        const _imgPreModif = `<div class="row no-gutters text-right imagem-lateral-artigo">
         <div class="offset-3 col-9 offset-md-4 col-md-8 offset-lg-4 col-lg-8 borda-imagem">
         </div>
         <div class="col-12">
             <img`;
        const _imgSufOrig = new RegExp(`;width: 100%"/>`, 'g');
        const _imgSufModif = `;width: 100%"/></div></div>`;


        const _subPreOrig = new RegExp(`<p><sub`, 'g');
        const _subPreModif = `<div class="legenda-imagem-lateral-artigo">
             <div class="col-12 pr-3">
                 <sub`;
        const _subSufOrig = new RegExp(`</sub></p>`, 'g');
        const _subSufModif = `</sub></div></div>`;

        const _floatLeft = new RegExp(`float:left`, 'g');
        const _floatCenter = new RegExp(`float:center`, 'g');
        const _floatRight = `float:right`;

        let _novoTexto = '';
        if (_texto.props) _novoTexto = _texto.props.dangerouslySetInnerHTML.__html
            .replace(_imgPreOrig, _imgPreModif)
            .replace(_subPreOrig, _subPreModif)
            .replace(_subSufOrig, _subSufModif)
            .replace(_imgSufOrig, _imgSufModif)
            .replace(_floatLeft, _floatRight)
            .replace(_floatCenter, _floatRight)
            ;
        return _novoTexto
    }

    criaTextoHTML(texto) {
        return { __html: texto }
    }

    render() {
        const { isOpen, toggle, previaTexto,  dtPublicacao, nomeSecao, autor, titulo, previaDescricao, sigla } = this.props;
        return (
            <Modal className="modal-preview-hk" size="lg" isOpen={isOpen}>
                <ModalHeader toggle={toggle}>Previsão de Artigo - HK</ModalHeader>
                <ModalBody>
                    <div className={`conteudo-${this.obtemTipoBadge(sigla).cardColor}`}>
                        <div className="col-10=2 px-0">
                            <div className="card bg-white mt-5 mb-3">
                                <div className="destaque-conteudo">
                                    <div className={`card-header bg-${this.obtemTipoBadge(sigla).cardColor}`}>
                                        <div className={`row border-light border-bottom bg-${this.obtemTipoBadge(sigla).cardColor}`}>
                                            <div className={`col-2 text-left text-white`}>
                                                <small>{moment(dtPublicacao).format("DD MMM YY")}</small>
                                            </div>
                                            <div className={`col-8 text-uppercase text-center text-white`}>
                                                <small><span>{nomeSecao}</span></small>
                                            </div>
                                            <div className="col-2 text-right">
                                                <span className={`text-white px-3`}>
                                                    <small>X min</small>
                                                </span>
                                                <span className={`badge bg-white ${this.obtemTipoBadge(sigla).textColorBadgeWhite}`}>
                                                    {sigla.toUpperCase()}
                                                </span>
                                            </div>
                                            <div className={`col-12 text-center pt-4 pb-3 px-5`}>
                                                <h4 className={`px-4 titulo-destaque tamanho-padrao ${this.obtemTipoBadge(sigla).textColorInside}`}>{titulo}</h4>
                                            </div>
                                            {(autor && autor !== '') && (
                                                <div className={`col-12 px-3 pb-2 text-center text-uppercase tamanho-padrao ${this.obtemTipoBadge(sigla).textColorDestaque}`}>
                                                    <small>por {autor}</small>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`card-body px-5 bg-${this.obtemTipoBadge(sigla).cardColor} ${this.obtemTipoBadge(sigla).textColorDestaque} text-center`}>
                                        <div className="row no-gutters px-5">
                                            <div className={`col-12 corpo-destaque tamanho-padrao`}>
                                                {previaDescricao}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body px-0 bg-white corpo-texto">
                                    <div className="row no-gutters px-5">
                                        <div className={`col-12 px-5 tamanho-padrao ${this.obtemTipoBadge(sigla).textColorOutside}`}>
                                            {/* <div dangerouslySetInnerHTML={this.props.criaTextoHTML
                                            (this.props.textoHTML)} /> */}
                                            {!!previaTexto && <div dangerouslySetInnerHTML={this.criaTextoHTML(this.adicionarDivImgs(previaTexto))} />}
                                            {/* {(this.adicionarDivImgs(previaTexto))}} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-outline-secondary" onClick={toggle}>Voltar</button>{' '}
                </ModalFooter>
            </Modal>
        );
    }
}   